export const EXPENSE_CATEGORIES = {
  FOOD: 'FOOD',
  FUN: 'FUN',
  CLOTHING: 'CLOTHING',
  GIFTS: 'GIFTS',
  PERSONAL_CARE: 'PERSONAL_CARE',
  SERVICE: 'SERVICE',
  UNECESSARY: 'UNECESSARY',
  SCHOOL: 'SCHOOL',
}

export const INCOME_CATEGORIES = {
  INÉ: 'INÉ',
  VŠ: 'VŠ',
  PRÁCA: 'PRÁCA',
  ČEPENIA: 'ČEPENIA',
  KŠEFT: 'KŠEFT',
  DARY: 'DARY',
}

export const PAYMENT_TYPES = {
  REVOLUT: 'REVOLUT',
  CASH: 'CASH',
  BANK: 'BANK',
}

export const PARAMS = {
  INCOMES: 'ZISKY',
  EXPENSES: 'VÝDAJE',
}
